import { render, staticRenderFns } from "./ReactionTestsTabNewTest.vue?vue&type=template&id=7ca344f0&"
import script from "./ReactionTestsTabNewTest.vue?vue&type=script&lang=js&"
export * from "./ReactionTestsTabNewTest.vue?vue&type=script&lang=js&"
import style0 from "./ReactionTestsTabNewTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReactionTestsTabNewTest.vue"
export default component.exports